// extracted by mini-css-extract-plugin
export default {"withPadding":"ReplyList-withPadding-eb2da9ffefc0851ed0228c9bcd3382b1"};